module.exports = __webpack_public_path__ + "img/checkbox.9511284d.svg";